import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import 'chartjs-adapter-date-fns';

import { DefaultModule, PrimeModule } from '@module';

import { ChartModule } from 'primeng/chart';

enum reportTimeScopeEnum {
  daily = 'daily',
  monthly = 'monthly',
  yearly = 'yearly',
}
@Component({
  selector: 'shared-line-chart',
  standalone: true,
  imports: [DefaultModule, PrimeModule, ChartModule],
  templateUrl: './shared-line-chart.component.html',
  styleUrl: './shared-line-chart.component.scss'
})
export class SharedLineChartComponent implements OnInit, OnChanges {
  @Input() dataList: { name: string; y: any; }[] = [];
  @Input() reportTimeScope: string;

  @Input() label: string;

  data: any;
  options: any;
  platformId = inject(PLATFORM_ID);
  constructor(
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    console.log('dataList', this.dataList);
    this.initChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataList'] || changes['reportTimeScope']) {
      console.log('dataList ', this.dataList);
      this.initChart();
    }

  }

  initChart() {
    // console.log('this.filter.view', this.filter.view);
    const formatDateOnly = (isoString: string) => isoString.slice(0, 10);
    const labels = this.dataList.length > 0 ? this.dataList.map(item => formatDateOnly(item.name)) : null;
    const data = this.dataList.length > 0 ? this.dataList.map(item => item.y) : null;

    if (isPlatformBrowser(this.platformId)) {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--p-text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
      const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

      this.data = {
        labels: labels,
        datasets: [
          {
            label: this.label,
            data: data,
            fill: false,
            borderColor: documentStyle.getPropertyValue('--p-cyan-500'),
            backgroundColor: documentStyle.getPropertyValue('--p-cyan-500'),
          },
        ]
      };

      this.options = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
          legend: {
            labels: {
              color: textColor
            }
          }
        },
        responsive: true,
        scales: {
          x: {
            type: 'time',
            stacked: true,
            time: {
              unit: this.reportTimeScope === reportTimeScopeEnum.daily ? 'day': this.reportTimeScope === reportTimeScopeEnum.monthly ? 'month' : 'year',
              tooltipFormat: 'dd/MM/yyy',
              displayFormats: {
                day: 'dd/MM/yyyy',
                month: 'MM/yyyy'
              }
            },
            ticks: {
              color: textColorSecondary
            },
            grid: {
              color: surfaceBorder,
              drawBorder: false
            }
          },
          y: {
            ticks: {
              color: textColorSecondary
            },
            grid: {
              color: surfaceBorder,
              drawBorder: false
            }
          }
        }
      };
      this.cd.markForCheck()
    }
  }
}
